import { gql } from "@apollo/client";

const CART_SYNC = gql`
  mutation CartSync(
    $cartId: String!
    $cartOpen: Boolean
    $guestCart: Boolean
    $items: JSON!
    $shippingPostalCode: String
    $shippingToZone: String
    $totalItems: Int
    $totalUniqueItems: Int
    $started: DateTime
  ) {
    cartSync(
      cart: {
        cartId: $cartId
        items: $items
        cartOpen: $cartOpen
        guestCart: $guestCart
        shippingPostalCode: $shippingPostalCode
        shippingToZone: $shippingToZone
        totalItems: $totalItems
        totalUniqueItems: $totalUniqueItems
        started: $started
      }
    ) {
      errors
      success
      cart {
        cartId
        cartOpen
        expirationDate
        guestCart
        items
        shippingPostalCode
        shippingToZone
        totalItems
        totalUniqueItems
      }
    }
  }
`;
const STRIPE_INTENT = gql`
  mutation StripeIntent($cartId: ID, $postalCode: String) {
    stripePayment(stripePayment: { cartId: $cartId, postalCode: $postalCode }) {
      errors
      success
      cart {
        cartId
      }
      stripePayment {
        id
        closed
        clientSecret
        isOpen
        opened
        success
      }
    }
  }
`;

const ADD_NEW_ORDER = gql`
mutation AddNewOrder($cartId: String = "", $fromCart: Boolean = true, $orderEmail:String!, $orderPhone:String! $multipleShippingAddresses: Boolean = false, $notes: String = "", $personId: ID = "") {
  addOrder(
    order: {cartId: $cartId, fromCart: $fromCart, multipleShippingAddresses: $multipleShippingAddresses, notes: $notes, personId: $personId, orderEmail:$orderEmail, orderPhone:$orderPhone}
  ) {
    success
    errors
    order {
      id
      fromCart
      orderDate
      customer {
        uuid
        firstName
        lastName
      }
      orderEmail
      orderPhone
      subtotal
      postageAmt
      taxAmt
      balanceDue
      balanceDueDate
      completed
      completionDate
      discountAmt
      inProgress
      multipleShippingAddresses
      notes
      orderTotalAmt
    }
  }
}
`

export {
    ADD_NEW_ORDER,
    CART_SYNC,
    STRIPE_INTENT,
}